import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:min-h-screen bg-gray-100 text-gray-800 antialiased px-4 py-20 flex flex-col justify-center sm:py-3" }
const _hoisted_2 = { class: "relative py-3 sm:max-w-xl w-full md:w-2/5 mx-auto text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-bold" }, "Login to your account", -1)
const _hoisted_4 = { class: "relative mt-4 bg-white shadow-md sm:rounded-lg text-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "h-2 asideBar rounded-t-md" }, null, -1)
const _hoisted_6 = { class: "py-6 px-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block font-semibold" }, "Username or Email", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-3 font-semibold" }, "Password", -1)

import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import UserService from '../services/userService'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter();

const loginInfo  = ref({
    userNameOrEmail:ref(''),
    password:ref(''),

})
const errorLogin = ref('')

const loginUser = () => {
    console.log(loginInfo.value)
    UserService.login(loginInfo.value)
    .then(( response: any ) => {

       localStorage.setItem("token", response.data.token);
       localStorage.setItem("type", response.data.user.type);
       router.push({ name: 'Statistics' });
    })
    .catch((error:any) => {
        // errorLogin.value = error.response.data
     console.log(error)
   });
}; 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginInfo.value.userNameOrEmail) = $event)),
              type: "text",
              placeholder: "Email",
              class: "border w-full h-5 px-3 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-sky-400 rounded-md"
            }, null, 512), [
              [_vModelText, loginInfo.value.userNameOrEmail]
            ]),
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginInfo.value.password) = $event)),
              type: "password",
              placeholder: "Password",
              class: "border w-full h-5 px-3 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-sky-400 rounded-md"
            }, null, 512), [
              [_vModelText, loginInfo.value.password]
            ]),
            _createElementVNode("div", { class: "flex justify-between items-baseline" }, [
              _createElementVNode("button", {
                onClick: loginUser,
                class: "mt-4 asideBar text-white py-2 px-6 rounded-lg hover:bg-[#2B8BD1]"
              }, "Login")
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})